module.exports = "<div class=\"buttons-zone\">\n    <div class=\"buttons-zone-left\">\n      <my-button *ngFor=\"let button of buttons.left\" [button]=\"button\"></my-button>\n    </div>\n    <div class=\"buttons-zone-center\">\n      <my-button *ngFor=\"let button of buttons.center\" [button]=\"button\"></my-button>\n    </div>\n    <div class=\"buttons-zone-right\">\n      <my-button *ngFor=\"let button of buttons.right\" [button]=\"button\"></my-button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/components/buttons/buttons.component.html
// module id = 727
// module chunks = 1